import _ from 'lodash'

export default (id, f, row, rowIndex, full, addl) => {
	const classNames = require("classnames")
	const value = _.get(f, `values.rows[${rowIndex}].${id}`, false)
	const error = _.get(f, `errors.rows[${rowIndex}].${id}`, false)
	const touched = _.get(f, `touched.rows[${rowIndex}].${id}`, false)
	//console.log(`value : ${value}, error : ${error}, touched : ${touched}`)

	if(row) {
		// This means it's like a traffic row - not an individual field.
		return classNames("form__listItem", {
			"form__listItem--full": full,
			//"form__fieldGroup--active": f.touched.rows[rowIndex][id] || false,
			"form__fieldGroup--error": error && touched,
			"form__fieldGroup--success": !error && value,
			"form__listItem--static": addl && addl.static
		})
	}
	else {
		return classNames("form__listItem", {
			"form__listItem--full": full,
			//"form__fieldGroup--active": f.touched[id],
			"form__fieldGroup--error": f.errors[id] && f.touched[id],
			"form__fieldGroup--success": !f.errors[id] && f.values[id],/*  && f.values[id].length !== 0 || f.values[id] === 0 */
			"form__listItem--static": addl && addl.static
		})
	}
	
}